function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { Style } from './style';
import { VECTOR_STYLE } from './constants';
export var DEFAULT_STYLE_NAME = 'default';
export var RUNTIME_PREFIX = 's_';
export var createDefaultStyle = function createDefaultStyle(name) {
  var style = {
    id: name || DEFAULT_STYLE_NAME,
    type: VECTOR_STYLE.OSKARI
  };
  return new VectorStyle(style);
};
export var VectorStyle = /*#__PURE__*/function (_Style) {
  function VectorStyle(_ref) {
    var _this;
    var id = _ref.id,
      title = _ref.name,
      style = _ref.style,
      type = _ref.type;
    _classCallCheck(this, VectorStyle);
    var name = id.toString();
    _this = _callSuper(this, VectorStyle, [name, title]);
    _this._type = type || VECTOR_STYLE.OSKARI;
    _this._styleDef = style || {};
    return _this;
  }

  /* override */
  _inherits(VectorStyle, _Style);
  return _createClass(VectorStyle, [{
    key: "getLegend",
    value: function getLegend() {
      return null;
    }

    /* override */
  }, {
    key: "getTitle",
    value: function getTitle() {
      var title = _superPropGet(VectorStyle, "getTitle", this, 3)([]);
      if (!title || title === DEFAULT_STYLE_NAME) {
        return Oskari.getMsg('MapModule', 'styles.defaultTitle');
      }
      return title;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this._type;
    }
  }, {
    key: "isRuntimeStyle",
    value: function isRuntimeStyle() {
      var name = this.getName() || '';
      return name.startsWith(RUNTIME_PREFIX);
    }
  }, {
    key: "hasDefinitions",
    value: function hasDefinitions() {
      return Object.keys(this.getFeatureStyle()).length > 0 || this.getOptionalStyles().length > 0;
    }
  }, {
    key: "getFeatureStyle",
    value: function getFeatureStyle() {
      if (this.getType() === VECTOR_STYLE.OSKARI) {
        return this._styleDef.featureStyle || {};
      }
      return this._styleDef;
    }
  }, {
    key: "getOptionalStyles",
    value: function getOptionalStyles() {
      if (this.getType() === VECTOR_STYLE.OSKARI) {
        return this._styleDef.optionalStyles || [];
      }
      // only oskari style has optional styles
      return [];
    }
  }, {
    key: "setStyleDef",
    value: function setStyleDef(styleDef) {
      this._styleDef = styleDef;
    }
  }]);
}(Style);